import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { compose } from "recompose";
import { getHeader, setHeader } from "src/redux/header";
import { IHeaderState } from "src/redux/header/reducer";

import { withCart } from "../../../../../hoc/repository";
import { IWithCart } from "../../../../../hoc/repository/withCart/withCart";
import { IAppState } from "../../../../../modules/reducers";

import Header, { IProps } from "./Header.component";

interface IMapStateToProps {
  header: IHeaderState;
}

export interface IDispatchProps {
  setHeader: typeof setHeader;
}

const mapDispatchToProps: IDispatchProps = {
  setHeader,
};

type IConnectedProps = RouteComponentProps &
  IWithCart &
  IDispatchProps &
  IMapStateToProps;

export type IContainerProps = Omit<IProps, keyof IConnectedProps>;

export default compose<IProps, IContainerProps>(
  connect(
    (state: IAppState): IMapStateToProps => ({
      header: getHeader(state),
    }),
    mapDispatchToProps
  ),
  withRouter,
  withCart
)(Header);
